import React from 'react';

import { Button, Gap, Gutter, Text } from '@common/components';

type Props = {
  email: string;
  onChange?: () => void;
};

export function SigningInAsHeader({ email, onChange }: Props) {
  if (!onChange) return null;

  return (
    <Gutter size="lg" direction="bottom">
      <Text weight="bold">Signing in as</Text>
      <Gap size="md" align="center">
        <Text>{email}</Text>
        <Button kind="link" size="sm" onClick={onChange}>
          Change
        </Button>
      </Gap>
    </Gutter>
  );
}
